export const LOAD_SERVICES = "LOAD_SERVICES";
export const SERVICES_LOADING = "SERVICES_LOADING";
export const LOAD_SUB_SERVICES = "LOAD_SUB_SERVICES";